var render, staticRenderFns
import script from "./SListRow.vue?vue&type=script&lang=ts&"
export * from "./SListRow.vue?vue&type=script&lang=ts&"
import style0 from "./SListRow.vue?vue&type=style&index=0&id=6da8f806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da8f806",
  null
  
)

export default component.exports